import React, { useEffect, useState } from "react";
import { renderToString, rendertostaticmarkup } from "react-dom/server";
import $ from "jquery";
import moment, { localeData } from "moment";
import jsPDF from "jspdf";
import "../App.css";
import "../style/style.css";
import "../style/sb-admin-2.min.css";
import "../style/perfect-scrollbar.css";
import "../font/css/all.min.css";
import logo from "../img/logos.png";
import user from "../img/user-1.png";
import Sidebar from "./sidebar";
import { getUser } from "../Firebase/API/user";
import { logOut } from "../Firebase/API/auth";
import {
  getCaseManagement,
  getCaseDetails,
} from "../Firebase/API/case_management";
import { getMenteeDetails } from "../Firebase/API/mentee";
import CsvDownload from "react-json-to-csv";
import autoTable from 'jspdf-autotable';
import PdfDocument from "./pdfcomponent";
import { PDFViewer, PDFDownloadLink } from '@react-pdf/renderer'

const Case = (props) => {
  const [caselog, setCaseLog] = useState([]);
  const [download, setDownload] = useState([]);
  const [mockdata, setMockdata] = useState([]);

  const [users, setUser] = useState({
    name: "",
    profile_pic: "",
    email: "",
  });
  useEffect(() => {
    // Get User Profile
    if (localStorage.getItem("token") != null) {
      const docid = localStorage.getItem("docid");
      getUser(docid)
        .then((result) => {
          setUser({
            name: result.name,
            profile_pic: result.profile_picture,
            email: result.profile_picture,
          });
        })
        .catch((error) => {
          // toast.error("Something went wrong!");
          console.log(" error ", error);
        });
    } else {
      props.history.push("/");
    }
  }, []);

  useEffect(() => {
    getCaseManagement((data) => {
      if (data) {
        setCaseLog(data);
      }
    });
  }, []);
  useEffect(() => {
    var width = window.innerWidth > 0 ? window.innerWidth : window.screen.width;
    if (width < 768) {
      $("body").addClass("sidebar-toggled");
      $("body").removeClass("sidebarclose");
      $("#accordionSidebar").addClass("toggled");
    }
  }, [0]);
  function signoff() {
    logOut((status) => {
      if (status) {
        localStorage.clear();
        props.history.push("/");
      }
    });
  }

  function onDownload(id, menteeid) {
    let name = "";
    // getMenteeDetails(menteeid, (data, status) => {
    //   if (status) {
    //     console.log(status)
    //     name = data.first_name + " " + data.last_name;
    //   }
    // });
    getCaseDetails(id, (data, status) => {
      if (status) {
       
        data.contact_date = new Date(
          data.contact_date.seconds * 1000
        ).toLocaleDateString("en-US");
      
        //@author kavita singh
        const doc = new jsPDF();
        autoTable(doc, { html: "#simple_table" });
        var finalY = doc.lastAutoTable.finalY || 10;
        doc.text("Case Management Log", 100, finalY + 35, "center");
        autoTable(doc, {
          startY: finalY + 40,
          tableWidth: 'auto',
          columnWidth: 'auto',
          bodyStyles: { overflow: 'linebreak', cellWidth: 'auto' },
          body: [
            ["Mentee Name", `${data.mentee_name}`],
            ["Mentor Name", `${data.mentor_name}`],
            ["Contact Date", `${data.contact_date}`],
            ["Meeting Duration", `${data.meeting_duration}`],
            ["Gender", `${data.gender}`],
            ["Ethnicity", `${data.ethnicity}`],
            ["Referral Type", `${data.referral_type.map((type) => type)}`],
            ["Employment Type", `${data.employment_type}`],
            ["Mentee Goal", `${data.mentee_goal}`],
            ["Risk Status", `${data.risk_status}`],
            ["Housing Status", `${data.housing_status}`],
            ["Session Activity",
              `${data.session_activity.map((type) => type)}`,
            ],
            ["Progress", `${data.progress}`],
            ["Steps", `${data.steps}`],
            ["Success", `${data.success}`],
            ["Comments", `${data.comments}`],
            ["Concern", `${data.concern}`],
          ],
        });
        var img = new Image();
        img.onload = function () {
          doc.addImage(this, 10, 10);
          doc.save("Caselog.pdf");
        };
        img.crossOrigin = "";

        img.src = "data:image/png;base64,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";
        //ending
      }
    });
  }

  function onDownloadCsv(id, menteeid) {
    let name = "";
    let dummy = [];
    getMenteeDetails(menteeid, (data, status) => {
      if (status) {
        name = data.first_name + " " + data.last_name;
      }
    });
    getCaseDetails(id, (data, status) => {
      if (status) {
        data.contact_date = new Date(
          data.contact_date.seconds * 1000
        ).toLocaleDateString("en-US");
        dummy = [
          [
            "Mentee Name",
            "Mentor Name",
            "Contact Date",
            "Meeting Duration",
            "Gender",
            "Ethnicity",
            "Referral Type",
            "Employment Type",
            "Mentee Goal",
            "Risk Status",
            "Housing Status",
            "Session Activity",
            "Progress",
            "Steps",
            "Success",
            "Comments",
            "Concern",
          ],
          [
            data.mentee_name,
            data.mentor_name,
            data.contact_date,
            data.meeting_duration,
            data.gender,
            data.ethnicity,
            data.referral_type,
            data.employment_type,
            data.mentee_goal,
            data.risk_status,
            data.housing_status,
            data.session_activity,
            data.progress,
            data.steps,
            data.success,
            data.comments,
            data.concern,
          ],
        ];
        setDownload(dummy);
      }
    });
  }
  useEffect(() => {
    if (document.getElementById("csv_id")) {
      document.getElementById("csv_id").click();
    }
  }, [download]);
  return (
    <div>
      <div id="wrapper">
        <Sidebar case={"active"} />
        {/* <table id="simple_table">  </table> */}
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <nav className="navbar navbar-expand navbar-light bg-white topbar mb-2 static-top">
              <button
                id="sidebarToggleTop"
                className="btn btn-link d-md-none rounded-circle mr-3"
              >
                <i className="fa fa-bars"></i>
              </button>
              <h3 className="my-heading">Case Management Log</h3>
            
              <ul className="navbar-nav ml-auto">
                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle"
                    href="#"
                    id="userDropdown"
                    role="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <img className="img-profile rounded-circle" src={user} />
                    <i className="fas fa-circle green-online"></i>
                    <span className="mr-2 d-none d-lg-inline small blue">
                      {users.name}
                    </span>
                  </a>
                  <div
                    class="dropdown-menu dropdown-menu-right shadow animated--grow-in"
                    aria-labelledby="userDropdown"
                  >
                    <a class="dropdown-item" onClick={signoff} href="/">
                      <i class="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                      Logout
                    </a>
                  </div>
                </li>
              </ul>
            </nav>

            <div className="container-fluid">
            {/* <PDFViewer>
            <PdfDocument   />
          </PDFViewer> */}
              <div className="row">
                <div className="col-xl-12 col-lg-12">
                  <div className="card custom-card pb-1">
                    <div className="card-body">
                      <div className="container bootstrap snippet">
                        <div className="my-4">
                          <div className="col-lg-12 col-md-12 col-12">
                            {caselog
                              .sort((a, b) =>
                                moment
                                  .unix(a.created_at.seconds)
                                  .format("MM/DD/YYYY") <
                                  moment
                                    .unix(b.created_at.seconds)
                                    .format("MM/DD/YYYY")
                                  ? 1
                                  : -1
                              )
                              .map((log, i) => (
                                <div
                                  style={{ "margin-bottom": "19px" }}
                                  class="row"
                                >
                                  <div class="col-md-8 col-lg-7 col-12">
                                    {i + 1}- {log.mentee_name} - Case Management
                                    - {log.mentee_goal}-{" "}
                                    {moment
                                      .unix(log.created_at.seconds)
                                      .format("MM/DD/YYYY")}{" "}
                                  </div>
                                  <div class="col-lg-5 col-md-4 col-12">
                                    <CsvDownload
                                      class="btn btn-outline-primary ml-3 display_none"
                                      data={download}
                                      filename={"caselog.csv"}
                                      id="csv_id"
                                    >
                                      <i class="far fa-file-pdf"></i> Download
                                      CSV{" "}
                                    </CsvDownload>
                                    <button
                                      type="button"
                                      class="btn btn-outline-primary mb-1"
                                      onClick={() =>
                                        onDownloadCsv(log.id, log.mentee_id)
                                      }
                                    >
                                      <i class="far fa-file-pdf"></i> Download
                                      CSV{" "}
                                    </button>
                                    <PDFDownloadLink document={<PdfDocument data={log} />} id="pdfdownload" fileName={`${log.mentee_name+i}.pdf`}>
                                      {({ blob, url, loading, error }) => (loading ? 'Loading document...' : 'download')}
                                      <button
                                      type="button"
                                      class="btn btn-outline-primary mb-1 ml-md-2 ml-lg-2 ml-xl-2"
                                
                                    >
                                      <i class="far fa-file-pdf"></i> Download
                                      PDF{" "}
                                    </button>
                                    </PDFDownloadLink>
                                    {/* <button
                                      type="button"
                                      class="btn btn-outline-primary mb-1 ml-md-2 ml-lg-2 ml-xl-2"
                                      onClick={() =>
                                        onDownload(log.id, log.mentee_id)
                                      }
                                    >
                                      <i class="far fa-file-pdf"></i> Download
                                      PDF{" "}
                                    </button> */}
                                  </div>
                                </div>
                              ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Case;
